import React from 'react';
import { comoFunciona, siteConfig } from '../../data/mock';
import { MessageCircle, ArrowRight } from 'lucide-react';

const ComoFuncionaSection = () => {
  const whatsappLink = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent(siteConfig.whatsappMessage)}`;

  return (
    <section className="py-24 bg-[#2a2523]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif text-white mb-4">
            <span className="text-[#c9a962]">Como funciona</span> nosso trabalho
          </h2>
        </div>
        
        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {comoFunciona.steps.map((step, index) =>
          <div
            key={index}
            className="group relative bg-[#3d3632] rounded-2xl p-8 transition-all duration-500 hover:bg-[#4a433e] border border-[#c9a962]/20">

              {/* Number badge */}
              <div className="absolute -top-4 -left-4 w-12 h-12 bg-[#c9a962] rounded-xl flex items-center justify-center shadow-lg">
                <span className="text-[#2a2523] font-bold text-lg">{step.number}</span>
              </div>
              
              {/* Icon - Clean square style */}
              <div className="w-16 h-16 border-2 border-[#c9a962]/50 rounded-lg flex items-center justify-center mb-6 group-hover:border-[#c9a962] transition-colors duration-300">
                <svg className="w-8 h-8 text-[#c9a962]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                  {index === 0 && <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />}
                  {index === 1 && <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />}
                  {index === 2 && <path strokeLinecap="round" strokeLinejoin="round" d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.448 14.9 14.9 0 01.06-.312m-2.24 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />}
                </svg>
              </div>
              
              {/* Content */}
              <h3 className="text-xl font-bold text-white mb-3">
                {step.title}
              </h3>
              <p className="text-neutral-400 leading-relaxed">
                {step.description}
              </p>
              
              {/* Decorative line connector */}
              {index < comoFunciona.steps.length - 1 &&
            <div className="hidden md:block absolute top-1/2 -right-4 w-8 h-0.5 bg-[#c9a962]/30" />
            }
            </div>
          )}
        </div>
        
        {/* CTA */}
        <div className="text-center">
          <p className="!text-lg mb-6 !text-[#BF7B2D]">
            {comoFunciona.cta}
          </p>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center justify-center gap-3 bg-emerald-600 hover:bg-emerald-500 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-emerald-500/25">

            <MessageCircle className="w-5 h-5" />
            {siteConfig.ctaText}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>);

};

export default ComoFuncionaSection;